export { default } from "./ProjectApprovalV1Mspa";
